import React from 'react';

import { Button, ButtonProps } from '@material-ui/core';

import { useStyles } from './styles';

const FloatingButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  color = 'primary',
  // color = 'secondary',
  variant = 'contained',
  disabled,
  ...props
}) => {
  const classes = useStyles();

  return (
    <Button
      {...props}
      variant={variant}
      color={color}
      className={classes.buttonBase}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default FloatingButton;
